module.exports = __webpack_public_path__ + "img/icon_comment.7e99c0a0.svg";